import { LOCALE_EN, LOCALE_RU } from '../constant';
import { FORMS_URL, getFetchRequest } from '../store/requests';
import {
    buildCsv,
    downloadCsvFile,
    getLocalizedName,
} from './csvExportUtils';
import { errorCallback, makeUrl } from '../util';

const FORMS_EXPORT_QUERY = '?withDeleted=true&withStatus=true';

const FORM_CSV_HEADERS = [
    'id',
    'formCode',
    'formType',
    'formGroup',
    'nameRu',
    'nameEn',
    'isDeleted',
    'dateCreated',
];

const mapFormToRow = (form) => [
    form.id || '',
    form.productForm || form.formCode || '',
    form.formType || '',
    form.formGroup || '',
    getLocalizedName(form.names, LOCALE_RU),
    getLocalizedName(form.names, LOCALE_EN),
    form.isDeleted === true ? 'true' : 'false',
    form.dateCreated || '',
];

export const exportFormsToCsv = (onComplete) => {
    getFetchRequest(
        makeUrl([FORMS_URL, FORMS_EXPORT_QUERY]),
        (forms) => {
            const rows = (forms || []).map(mapFormToRow);
            const csv = buildCsv(FORM_CSV_HEADERS, rows);
            downloadCsvFile('product-forms.csv', csv);
            onComplete?.();
        },
        (err) => {
            errorCallback(err);
            onComplete?.();
        },
    );
};
